import { render } from "./yi-pl35.vue?vue&type=template&id=3a098efd&scoped=true"
import script from "./yi-pl35.vue?vue&type=script&lang=js"
export * from "./yi-pl35.vue?vue&type=script&lang=js"

import "./yi-pl35.vue?vue&type=style&index=0&id=3a098efd&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a098efd"]])

export default __exports__